/**
 * A NAME and a semver VERSION as two fields — the convention the mental-model
 * detectors (`DETECTOR_VERSION`), the layout rule (`rule_version`), the catalog
 * generators (`generator_version`) and the defeature recipe (`recipe_version`)
 * share (spec 2026-10-19-optomech-catalog-composition-design.md §6.2
 * "Versioning"). The major bumps when existing output changes, the minor for a
 * new capability or field, the patch for a message.
 */
export const SEMVER_RE = /^\d+\.\d+\.\d+$/;

/**
 * The `name@N` shorthand the generators and the defeature recipe carried
 * before the version became its own field (2026-10-20): `defeature@1` is
 * `defeature` at `1.0.0`. Rows written before then still hold it — a run's
 * `geometry_used`, a saved system's `cad_import.defeaturing` — and are read
 * through this split, never rewritten; nothing writes the shorthand any more.
 */
export function splitLegacyVersionedName(packed: string): { name: string; version: string } {
  const match = /^([a-z_]+)@([1-9]\d*)$/.exec(packed);
  if (!match) throw new Error(`not a name@N identifier: ${packed}`);
  return { name: match[1], version: `${match[2]}.0.0` };
}
